import { AnchorTarget } from 'root/src/client/v2/_pages/content/redesign/AnchorTarget';
import { legalClasses } from 'root/src/client/v2/_pages/legal/redesign/legalClasses';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// One legal section: an anchored block with a font-display heading, an optional Terms summary box, and
// the verbatim legacy content. Heading sizes / spacing reproduce the legacy `style.js` (`sectionTitle`
// ~22px, generous top margin) on redesign tokens. The anchor `id` sits on the shared offset
// `AnchorTarget` so the reused react-scroll TOC lands the heading clear of the fixed navbar.
export const LegalSection = ({ id, title, summary, children, className }) => (<section className={cn('relative scroll-mt-[88px] pb-8', className)}>
		{id ? <AnchorTarget id={id}/> : null}
		{title ? (<h2 className="mb-4 font-display text-xl font-semibold text-foreground sm:text-2xl">{title}</h2>) : null}
		{summary ? (<p className={cn('mb-5', legalClasses.mainParagraph)}>{summary}</p>) : null}
		{children}
	</section>);
